import * as types from 'src/store/types';
export default {
  updateAvailableEvents (state, data) {
    state.available = data
    // Проверяем если указано текущее мероприятие, но оно не из данного бренда, то производим сброс
  },
  changeCurrent (state, data) {
    if (data === null) {
      state.current = null
      sessionStorage.removeItem('current_event')
    } else if (data instanceof Number) {
      state.current = data
      sessionStorage.setItem('current_event', data)
      this.dispatch('events/updateEventInfo')
    } else {
      state.currentEventInfo = data
      state.current = data.id
      sessionStorage.setItem('current_event', data.id)
      this.dispatch('events/updateEventInfo')
    }
  },
  resetCurrent (state) {
    state.current = null
    state.currentEventInfo = null
    sessionStorage.removeItem('current_event')
  }
};
